// API configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Vagaro embedded booking widget loader (baked at build time, like API_BASE_URL).
// Double slash after `.com` is intentional — copied verbatim from Vagaro's snippet.
export const VAGARO_WIDGET_SRC =
  'https://www.vagaro.com//resources/WidgetEmbeddedLoader/OZqqDZOvDJacT3qmV35y79oz34mC2PeFJ4mC30m9dSycvCu7gevEhAJDXwOapcUbfY?v=4zHpjTy7ON5DYb50dy4iNkLBm0byXpRMpC0OsCH1k2Ym#';
